export default function tokensReducer(state = {}) {
  return state;
}
